import { styled } from 'styled-components';

import { colors, cssBreakpoints, fontWeights } from 'theme/theme';

export const ViewJobPageSidebarResultsHolder = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ViewJobPageSidebarSuggestionsHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
`;

export const ViewJobPageSidebarResultsHeaderTitle = styled.h4`
  display: none;
  font-size: 16px;
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.normal};
  margin: 0;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: block;
  }
`;
